<template>
	<div class="site-cookiebar">
		<div class="site-cookiebar__container">
			<div class="row align-items-center">
				<div class="col-8 col-md-9 d-flex align-items-center site-cookiebar__text" v-html="t('site.cookiebar.text')">

				</div>
				<div class="col-4 col-md-3 d-flex align-items-end">
					<button class="btn btn--small btn--primary" @click="setCookie">
						{{t('site.cookiebar.btn')}}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "CookieBar",
		methods:{

			setCookie(){
				this.$store.commit('setCookieBar');
			}
		}
	}
</script>

<style lang="scss">

</style>